export const DUPLICATE_CONTACT_EMAIL_ERROR = 'All contact emails must be unique';
export const DUPLICATE_CONTACT_EMAIL_SNACKBAR = 'Email addresses must be unique.';

export function normalizeContactEmail(email?: string | null): string {
    return email?.trim().toLowerCase() ?? '';
}

export function getDuplicateEmailIndices(emails: (string | null | undefined)[]): number[] {
    const seen = new Map<string, number>();
    const duplicates = new Set<number>();

    emails.forEach((email, index) => {
        const normalized = normalizeContactEmail(email);
        if (!normalized) return;

        const firstIndex = seen.get(normalized);
        if (firstIndex !== undefined) {
            duplicates.add(firstIndex);
            duplicates.add(index);
        } else {
            seen.set(normalized, index);
        }
    });

    return Array.from(duplicates);
}

export function hasDuplicateContactEmails(emails: (string | null | undefined)[]): boolean {
    return getDuplicateEmailIndices(emails).length > 0;
}

export function syncDuplicateContactEmailErrors<K extends string>(
    emails: (string | null | undefined)[],
    existingErrors: Array<Partial<Record<K | 'email', string>>>,
    duplicateEmailError: string = DUPLICATE_CONTACT_EMAIL_ERROR,
): Array<Partial<Record<K | 'email', string>>> {
    const duplicateIndices = new Set(getDuplicateEmailIndices(emails));

    return existingErrors.map((existing, index) => {
        const next = { ...existing };
        if (duplicateIndices.has(index)) {
            next.email = duplicateEmailError;
        } else if (next.email === duplicateEmailError) {
            delete next.email;
        }
        return next;
    });
}
